import { faStickyNote } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Empty, Modal, Space, Tabs, Typography } from 'antd'
import dayjs from 'dayjs'
import { Visit } from '../../domain/jobs/jobs'

type Props = {
  open: boolean
  visits: Visit[]
  onSelectVisit: (visitId: string) => void
  onClose: () => void
}

type NoteKind = 'clientNotes' | 'internalNotes'

const VisitNotesModal = ({ open, visits, onSelectVisit, onClose }: Props) => {
  const renderNotes = (kind: NoteKind) => {
    const withNotes = visits.filter(visit => !!visit[kind])

    if (withNotes.length === 0) {
      return <Empty description="No notes" image={Empty.PRESENTED_IMAGE_SIMPLE} />
    }

    return <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      {withNotes.map(visit => <article key={visit.id}>
        <Typography.Link onClick={() => onSelectVisit(visit.id)} title="View this visit">
          {dayjs(visit.date).format('MM/DD/YYYY')} - {visit.owner}
        </Typography.Link>
        <Typography.Paragraph style={{ whiteSpace: 'pre-wrap' }}>{visit[kind]}</Typography.Paragraph>
      </article>)}
    </Space>
  }

  return <Modal
    title="Visits Notes"
    open={open}
    onCancel={onClose}
    width={900}
    footer={<Button onClick={onClose}>Close</Button>}
  >
    <Tabs items={[
      {
        key: 'client',
        label: <Space><FontAwesomeIcon icon={faStickyNote} />Client Notes</Space>,
        children: renderNotes('clientNotes')
      },
      {
        key: 'internal',
        label: <Space><FontAwesomeIcon icon={faStickyNote} />Internal Notes</Space>,
        children: renderNotes('internalNotes')
      }
    ]} />
  </Modal>
}

export default VisitNotesModal
